export const formatTime = (
  timeInSeconds: number,
  isDurationFormat: boolean = false,
  hourTitle?: string,
  minuteTitle?: string,
) => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);

  if (isDurationFormat) {
    let time = '';

    if (hours > 0) {
      time += `${hours} ${hourTitle || 'ч'}`;
    }

    time += ` ${minutes} ${minuteTitle || 'мин'}`;

    return time;
  }

  const formattedHours = hours > 0 ? `${hours.toString().padStart(2, '0')}:` : '';
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return `${formattedHours}${formattedMinutes}:${formattedSeconds}`;
};

// ----------------------------------------------------------------

export function getMonthsFromDays(days: number): number {
  const averageDaysInMonth = 30.44; // 365 / 12
  return Math.ceil(days / averageDaysInMonth);
}

// ----------------------------------------------------------------

export function formatDate(isoString: string, hasHours?: boolean): string {
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  if (hasHours) {
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  } else {
    return `${day}.${month}.${year}`;
  }
}
